import type {
  F01InsightBreakdown,
  F01InsightPopulation,
  F01InsightReport,
} from "@care-by-ella/contracts";
import { API_BASE, apiFetch, tenantHeader, withCredentials } from "./api";
import { jsonOr401 } from "./clinician-api";

// TES-1326 — the F-01 insight view client (admin-only endpoint).

export class F01InsightsApiError extends Error {}

/** The view is switched off on this box (F01_INSIGHTS_MODE=off). */
export class F01InsightsDisabledError extends Error {}

export async function fetchF01Insights(
  period: string,
  breakdown: F01InsightBreakdown,
  population: F01InsightPopulation = "patients",
): Promise<F01InsightReport> {
  const qs = new URLSearchParams({ period, breakdown, population });
  const res = await apiFetch(`${API_BASE}/employee-api/v1/f01-insights?${qs}`, {
    headers: tenantHeader(),
    ...withCredentials,
  });
  if (res.status === 401 || res.status === 403) {
    return jsonOr401<F01InsightReport>(res);
  }
  if (res.status === 404) {
    const body = (await res.json().catch(() => null)) as { error?: string } | null;
    // TES-1403 — the web population switched off is the same case for the
    // page: there is nothing to show.
    if (
      body?.error === "f01_insights_disabled" ||
      body?.error === "f01_insights_population_disabled"
    ) {
      throw new F01InsightsDisabledError();
    }
  }
  if (!res.ok) throw new F01InsightsApiError(`HTTP ${res.status}`);
  return (await res.json()) as F01InsightReport;
}
